import React from 'react';
import ContactFormSection from '../components/ContactFormSection';

const officialImage =
  'https://png.pngtree.com/png-clipart/20250518/original/pngtree-three-golden-chess-pieces-png-image_21017699.png';

const principles = [
  {
    title: 'Mission',
    icon: '♔',
    text: 'To expand access to quality chess instruction and support meaningful chess development throughout The Bahamas.',
  },
  {
    title: 'Leadership',
    icon: '♕',
    text: 'The Institute is led by FIDE Master Cecil Moncur and guided by a commitment to professionalism, consistency and student growth.',
  },
  {
    title: 'Approach',
    icon: '♖',
    text: 'Programs are designed to develop strategic thinking, discipline and confidence through structured instruction and practical play.',
  },
  {
    title: 'Community',
    icon: '♘',
    text: 'The Institute partners with families, schools and local stakeholders to build a stronger and more active chess culture.',
  },
];

const contactImage =
  'https://img.freepik.com/premium-photo/classic-chess-board-transparent-background_971989-23533.jpg';

function AboutPage() {
  return (
    <div className="page-stack">
      <section className="hero-grid">
        <div className="hero-copy">
          <div className="eyebrow">About the Institute</div>
          <h1>Official Information</h1>
          <p className="hero-text">
            The Bahamas Chess Institute is a chess education and development organization serving
            students, families, schools and the wider chess community in The Bahamas.
          </p>

          <div className="detail-list surface-card about-summary-card">
            <div>
              <span className="detail-label">Name</span>
              <span>The Bahamas Chess Institute</span>
            </div>
            <div>
              <span className="detail-label">Founder</span>
              <span>FIDE Master Cecil Moncur</span>
            </div>
            <div>
              <span className="detail-label">Core Work</span>
              <span>Lessons, scholastic programming and tournament development</span>
            </div>
          </div>
        </div>

        <div className="image-card-wrap about-image-wrap">
          <div className="about-image-card">
            <img src={officialImage} alt="Official chess pieces visual" />
          </div>
        </div>
      </section>

      <section className="content-section">
        <div className="section-heading">
          <div className="eyebrow">Guiding Principles</div>
          <h3>What defines the Institute</h3>
          <p>
            The Institute operates with a clear educational focus and a long-term commitment to
            raising the standard of chess development nationally.
          </p>
        </div>

        <div className="card-grid four-up">
          {principles.map((item) => (
            <article className="surface-card info-card compact-card" key={item.title}>
              <h4 className="principle-title">
                <span className="principle-icon" aria-hidden="true">{item.icon}</span>
                {item.title}
              </h4>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </section>

      <ContactFormSection
        title="Send an enquiry to the Institute"
        description="Share your question and your email app will open with your message prepared and addressed to The Bahamas Chess Institute."
        subjectPrefix="About Page Enquiry"
        enquiryOptions={['General Enquiry', 'Lessons and Programs', 'Tournaments and Events']}
        imageSrc={contactImage}
        imageAlt="Chess board visual"
      />
    </div>
  );
}

export default AboutPage;
